import React from 'react';
import styled from '@emotion/styled';

const InvalidLinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background-color: #f8f8f8;
  font-family: Arial, sans-serif;
`;

const PhoneImageBackground = styled.div`
  position: relative;
  width: 100%;
  max-width: 500px;
  height: 100vh;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`;

const PhoneOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const LogoContainer = styled.div`
  margin-top: 280px;
  margin-bottom: 30px;
`;

const Logo = styled.img`
  width: 100px;
  opacity: 0.7;
`;

const ErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 340px;
  margin: 0 auto;
`;

const ErrorTitle = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
`;

const ErrorDescription = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: #555;
  margin-bottom: 30px;
`;

const ContactInfo = styled.p`
  font-size: 18px;
  color: #000;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.8);

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const ContactLink = styled.a`
  color: #0078d4;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;

const ProjectClosedScreen = ({
  backgroundImageUrl = '',
  logoSrc = 'logo.png',
  title = 'Project is Closed',
  description = 'This project has ended and is no longer accepting responses',
}) => {
  return (
    <InvalidLinkContainer>
      <PhoneImageBackground style={{ backgroundImage: backgroundImageUrl ? `url(${backgroundImageUrl})` : undefined }}>
        <PhoneOverlay>
          <LogoContainer>
            <Logo src={logoSrc} alt="Exploratory Logo" />
          </LogoContainer>

          <ErrorContent>
            <ErrorTitle>Project is Closed</ErrorTitle>
            <ErrorDescription>{description}</ErrorDescription>
            <ContactInfo>
              For Help: <ContactLink href="mailto:contact@explorastory.in">contact@explorastory.in</ContactLink>
            </ContactInfo>
          </ErrorContent>
        </PhoneOverlay>
      </PhoneImageBackground>
    </InvalidLinkContainer>
  );
};

export default ProjectClosedScreen;
